<template>
	<div id="app" v-if="isShow">
		<transition name="router-fade" mode="out-in">
			<router-view />
		</transition>
		<div class="mask_wx" v-if="isWx">
			<img src="./images/mask_wx.png" alt="" />
		</div>
	</div>
</template>

<script>
import { QueryString } from './js/common';
import { PROXY_URL } from './config/env';
import { GetNotifyKey, QueryBindChannelStore } from './service/getData';
export default {
	name: 'App',
	data() {
		return {
			isWx: false,
			isShow: false
		};
	},
	async created() {
		let channel = this.getUrl('channel') || '';
		let virtualPrefix = '';
		if (channel) {
			let ary = channel.split('_');
			// 如果找到下划线，则截取下划线之前的字符串，否则返回原字符串
			virtualPrefix = ary[0];
		}

		await QueryBindChannelStore({
			virtualPrefix
		})
			.then(({ data }) => {
				if (data.result.channel) {
					this.$store.commit('setBusinessNo', data.result.channel);
					this.$store.commit('setChannel', data.result.channel);
					this.$store.commit('setVirtualChannel', channel);
					sessionStorage.setItem('businessNo', data.result.channel);
					sessionStorage.setItem('channel', data.result.channel);
					sessionStorage.setItem('virtualChannel', channel);
					this.isShow = true;
				} else {
					this.updateChannel();
					this.isShow = true;
				}
			})
			.catch(() => {
				this.updateChannel();
				this.isShow = true;
			});
	},
	mounted() {
		let channel = this.getUrl('channel') || '';
		let shq = this.getUrl('shq') || '';
		if (channel.indexOf('zhwk') > -1) {
			localStorage.setItem('zhwk', true);
		}
		if (shq) {
			localStorage.setItem('shq', true);
		}
		this.maskWx();
		this.isMobile();
		const ttclick = QueryString('adid') || this.getUrl('adid'); // 头条
		GetNotifyKey({
			businessNo: QueryString('channel') || this.getUrl('channel')
		}).then((res) => {
			let vid = res.data.result;
			let vidValue = QueryString(vid) || this.getUrl(vid);
			if (ttclick) {
				// 头条存储location.href
				if (QueryString(vid)) {
					// query
					let href = decodeURIComponent(window.location.href.replace(location.hash, ''));
					sessionStorage.setItem('ttclick', href);
				} else if (this.getUrl(vid)) {
					// 如果拼在hash值后面
					let arr = window.location.href.split('?');
					let href = decodeURIComponent(window.location.href.replace(location.hash, ''));
					sessionStorage.setItem('ttclick', `${location.origin}?${arr[arr.length - 1]}`);
				}
				return false;
			}
			sessionStorage.setItem(vid, vidValue);
		});

		const initiatorId = this.getUrl('initiatorId') || '';
		const assistModeType = this.getUrl('assistModeType') || '';
		if (initiatorId) {
			sessionStorage.setItem('initiatorId', initiatorId);
			sessionStorage.setItem('assistModeType', assistModeType);
		}

		let that = this;
		window['goRightPage'] = function () {
			that.goRightPage();
		};
	},
	methods: {
		updateChannel() {
			let channel = this.getUrl('channel') || '';
			let newChannel = 'android_xubeimH5';

			if (channel) {
				switch (channel) {
					case 'fengqun':
						newChannel = 'Android_mtf_fengqun';
						break;
					case 'xubeiwb1':
						newChannel = 'Android_mtf_xubeiwb1';
						break;
					case 'xubeiwb2':
						newChannel = 'Android_mtf_xubeiwb2';
						break;
					case 'xubeiwb3':
						newChannel = 'Android_mtf_xubeiwb3';
						break;
					case 'xubeiwb4':
						newChannel = 'Android_mtf_xubeiwb4';
						break;
					case 'xubeiwb5':
						newChannel = 'Android_mtf_xubeiwb5';
						break;
					default:
						break;
				}

				sessionStorage.setItem('newChannel', newChannel);
				sessionStorage.setItem('channel', channel);
				this.$store.commit('setChannel', channel);
			}
		},
		getUrl(name) {
			let url = window.location.href;
			var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
			var r = !url.split('?')[1] ? '' : url.split('?')[1].match(reg);
			if (!!r) return decodeURI(r[2]);
			return null;
		},
		isMobile() {
			let mobile = navigator.userAgent.match(
				/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
			);
			let url = window.location.href.indexOf('complaint_advice') > -1;
			if (!mobile && url) {
				window.location.href = `http://user.${PROXY_URL.domain}/complaint_advice`;
			}
		},
		maskWx() {
			let ua = navigator.userAgent.toLowerCase();
			let isWeixin = ua.indexOf('micromessenger') != -1;
			// if (isWeixin) {
			//   this.isWx = true;
			// }
		},
		goRightPage(orderNo) {
			window.location.href = `http://m.${PROXY_URL.domain}/#/rightsProblem?orderNo=${orderNo}`;
		},
		goRightPage(orderNo) {
			window.location.href = `http://m.${PROXY_URL.domain}/#/rightsProblem?orderNo=${orderNo}`;
		}
	}
};
</script>

<style lang="scss">
@import './style/reset';

// 引入阿里icon
@font-face {
	font-family: 'iconfont'; /* project id 252520 */
	src: url('//at.alicdn.com/t/font_252520_bl2ny27ff54.eot');
	src: url('//at.alicdn.com/t/font_252520_bl2ny27ff54.eot?#iefix') format('embedded-opentype'), url('//at.alicdn.com/t/font_252520_bl2ny27ff54.woff') format('woff'),
		url('//at.alicdn.com/t/font_252520_bl2ny27ff54.ttf') format('truetype'), url('//at.alicdn.com/t/font_252520_bl2ny27ff54.svg#iconfont') format('svg');
}

#app {
	.mask_wx {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.94);
		overflow: hidden;
		img {
			display: block;
			width: px2rem(750rem);
			height: px2rem(270rem);
			margin: 0.12rem auto;
		}
	}
}

.router-fade-enter-active,
.router-fade-leave-active {
	transition: opacity 0.1s;
}
.router-fade-enter,
.router-fade-leave-active {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue